import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { TableNameAvatarCell } from "@myplay/ui";

import { GREEN_LIGHT } from '../../styles/colors';
import { TableIconsCell } from '..';
import { capitalize } from '../../utils/stringManipulations';
import I18N from "../../I18N";

const MyTeamsTableItem = ({ name, category, season, members, videosCount, highlightsCount, onDelete, code }) => {
  const { coaches, players } = members;
  const [ shouldDisplayCopiedMessage, setShouldDisplayCopiedMessage ] = useState(false);

  const handleTeamCodeClick = event => {
    event.stopPropagation();
    setShouldDisplayCopiedMessage(true);
    navigator.clipboard.writeText(code);
    setTimeout(()=> {
      setShouldDisplayCopiedMessage(false);
    },2000)
  }

  return (
    <Fragment>
      <span className="team-name">{name}</span>
      <span>{category.name}</span>
      <span>{season}</span>
      <div className="coach">
        {coaches.length > 0 ?
          <TableNameAvatarCell
            firstName={coaches[0].firstName}
            lastName={coaches[0].lastName}
            avatar={coaches[0].avatar}
          /> : null 
        }
        {coaches.length > 1 &&
          <span style={{ color: GREEN_LIGHT }}>(+{coaches.length - 1})</span>
        }
      </div>
      <span>{players.length}</span>
      <span>{videosCount}</span>
      <span>{highlightsCount}</span>
      <button className="team-code-button" type="button" onClick={ event => handleTeamCodeClick(event)}>
        <span 
          style={{ fontSize: shouldDisplayCopiedMessage ? '12px' : 'inherit' }} 
        >
          {shouldDisplayCopiedMessage ? capitalize(I18N.t("COPIED_TO_CLIPBOARD")) : code}
        </span>
      </button>
      <div>
        <TableIconsCell onDeleteClick={onDelete}/>
      </div>
    </Fragment>
  );
};

MyTeamsTableItem.propTypes = {
  coaches: PropTypes.array,
  highlights: PropTypes.number,
  members: PropTypes.object,
  name: PropTypes.string,
  onDelete: PropTypes.func, 
  season: PropTypes.string,
  sport: PropTypes.string,
  videos: PropTypes.number,
  winLose: PropTypes.string,
};

MyTeamsTableItem.defaultProps = {
  coaches: [],
  highlights: 0,
  members: {
    coaches: [], 
    players: []
  },
  name: "",
  onDelete: ()=> {},
  season: "",
  sport: "",
  videos: 0,
  winLose: "",
};

export default MyTeamsTableItem;